// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-632c753c] .el-upload {\n  display: none;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 37>"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","file":"fileUploadNoUI.vue","sourcesContent":["/deep/.el-upload {\n  display: none;\n}"]}]);
// Exports
module.exports = exports;
